import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { Breakpoint, Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Image } from '../image/image.component';
import { MenuPosition } from '../menuPosition/menuPosition.component';

import { CollectionBoxProps, ContainerProps } from './collectionBoxes.types';

export const CollectionBoxMenuPosition: StyledComponent<typeof MenuPosition> = styled(MenuPosition)`
  width: 100%;
  height: 100%;
`;

export const CollectionBox: StyledComponent<'div', CollectionBoxProps> = styled.div<CollectionBoxProps>`
  ${({ $isSmallBox }: CollectionBoxProps): FlattenSimpleInterpolation => $isSmallBox ? css`
    min-width: 40%;
  ` : css`
    width: 100%;
  `};
  height: 660px;
  position: relative;
  overflow: hidden;

  & + & {
    margin-left: 10px;

    ${({ $withMobileMosaicTheme }: CollectionBoxProps): FlattenSimpleInterpolation | false => !$withMobileMosaicTheme && css`
      @media ${Breakpoint.Mobile} {
        margin-top: 10px;
        margin-left: 0;
      }
    `}

    @media ${Breakpoint.SmallMobile} {
      margin-left: 0;
      margin-top: 10px;
    }
  }

  @media ${Breakpoint.Tablet} {
    height: 416px;
  }

  @media ${Breakpoint.Mobile} {
    height: 332px;
  }

  @media ${Breakpoint.SmallMobile} {
    height: ${({ $isSmallBox, $withMobileMosaicTheme }: CollectionBoxProps): string => (
    $withMobileMosaicTheme && $isSmallBox ? '320px' : '200px'
  )};
  }
`;

export const CollectionBoxesContainer: StyledComponent<'div'> = styled.div`
  display: flex;

  & + & {
    margin-top: 10px;
  }

  @media ${Breakpoint.SmallMobile} {
    flex-direction: column;
    width: 50%;

    & + & {
      margin-left: 10px;
      margin-top: 0;
    }
  }
`;

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  width: 100%;

  @media ${Breakpoint.SmallMobile} {
    ${({ $withMobileMosaicTheme }: ContainerProps): string | false => $withMobileMosaicTheme && 'display: flex'};
  }
`;

export const BackgroundImage: StyledComponent<typeof Image> = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: .3s;

  &:hover {
    transform: scale(1.2);

    @media ${Breakpoint.Mobile} {
      transform: none;
    }
  }
`;

export const Label: StyledComponent<'div'> = styled.div`
  position: absolute;
  bottom: 24px;
  left: 24px;
  font-weight: ${FontWeight.Medium};
  font-size: 22px;
  line-height: 28px;
  letter-spacing: -0.01em;
  color: ${Color.White};
  padding-right: 24px;

  @media ${Breakpoint.Tablet} {
    bottom: 20px;
    left: 20px;  
    font-size: 18px;
    line-height: 26px; 
    padding-right: 20px;
  }

  @media ${Breakpoint.SmallMobile} {
    font-size: 16px;
    line-height: 22px; 
  }
`;
